// extracted by mini-css-extract-plugin
module.exports =  {"slides":"slides--X5TTD","slide":"slide--JkI7d"};